import { render } from "./Keyword.vue?vue&type=template&id=3ba57a31&scoped=true"
import script from "./Keyword.vue?vue&type=script&lang=js"
export * from "./Keyword.vue?vue&type=script&lang=js"

import "./Keyword.vue?vue&type=style&index=0&id=3ba57a31&scoped=true&lang=css"

import exportComponent from "/home/runner/work/adx-front-end/adx-front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ba57a31"]])

export default __exports__